
<template>
  <div class="header">
    <!-- 头部区域 -->
    <el-header class="cont_flex">
      <div class="top_head_left">

        <span style="width: 200px;display: inline-block">{{shop?shop.name:''}}</span>
        <div class="top_head_center">
          <i class="el-icon-date"></i>
          <span style="font-size:14px;">{{ nowDate }}</span>
          <span style="font-size:14px;">{{ nowWeek }}</span>
        </div>
      </div>
      <div class="top_head_right cont_flex_1">
        <!-- <el-dropdown class="margin_right" @command="getCampusList">
            <el-button type="primary">
                {{ this.campusNow
                }}<i class="el-icon-arrow-down el-icon--right"></i>
            </el-button>
            <el-dropdown-menu slot="dropdown">
                <el-dropdown-item
                    v-for="item in campusList"
                    :key="item.id"
                    :command="item.id"
                    >{{ item.name }}
                    </el-dropdown-item
                >
            </el-dropdown-menu>
        </el-dropdown> -->
        <el-dropdown class="margin_right">
          <el-button type="primary">
            <!-- <img src="https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg" /> -->
            当前登录的账号：{{ userName }}<i class="el-icon-arrow-down el-icon--right"></i>

          </el-button>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item @click.native="changePassword">修改密码</el-dropdown-item>
            <el-dropdown-item @click.native="userInfo">用户中心</el-dropdown-item>
            <el-dropdown-item @click.native="logout">注销</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </el-header>
    <!-- 新增编辑弹框 -->
    <el-dialog title="修改账号" :visible.sync="dialogPassword" width="550px" :append-to-body="true">
      <el-form :model="pwdForm" :rules="pwdRules" ref="pwdForm" label-width="80px">

        <el-form-item label="账号" prop="user_name">
          <el-input v-model="pwdForm.user_name" readonly autocomplete="off" placeholder="请输入账号"></el-input>
        </el-form-item>
        <el-form-item label="密码" prop="password">
          <el-input v-model="pwdForm.password" autocomplete="off" placeholder="请输入密码"></el-input>
        </el-form-item>
        <el-form-item label="确认密码" prop="repassword">
          <el-input v-model="pwdForm.repassword" autocomplete="off" placeholder="请再次输入密码"></el-input>
        </el-form-item>

      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="pwdReset_dialogForm('pwdForm')">取 消</el-button>
        <el-button type="primary" @click="pwdSubmitForm('pwdForm')">确 定</el-button>
      </div>
    </el-dialog>

  </div>
</template>
<script>
  import { hexMD5 } from '../../utils/md5' //引入


  export default {
    name:"HeaderView",
    data(){
      return {
        shop:{},
        nowWeek: "",
        nowDate: "",

        userName: '',

        campusList: [],
        campusNow: "",
        model:'',
        ip: "",

        dialogPassword: false,
        pwdForm: {
          user_name: sessionStorage.getItem('userName'),
          password: '',
          repassword: '',
        },
        pwdRules: {
          password: [
            { required: true, message: "请输入密码", trigger: "blur" }
          ],
          repassword: [
            { required: true, message: "请再次输入密码", trigger: "blur" }
          ],
        },
      }
    },
    created() {
      this.setNowTimes()
      this.campus()
      this.userName = window.sessionStorage.getItem('userName');
      this.shop= JSON.parse(sessionStorage.getItem("shop"));

    },
    methods:{
      campus() {
        if (localStorage.getItem("campus") != null) {
          this.campusNow = localStorage.getItem("campus");
          if (this.campusNow == 1) {
            this.campusNow = "中国";
          }
          if (this.campusNow == 2) {
            this.campusNow = "泰国";
          }
          if (this.campusNow == 3) {
            this.campusNow = "韩国";
          }
        }
        if (this.campusList.length == 0) {
          // this.$axios.get("campus.json").then((res) => {
          //     if (res.status == 200) {
          //     console.log(res.data.campus);
          //     this.campusList = res.data.campus;
          //     } else {
          //     this.$message.error("地区国家获取失败，请联系管理员~");
          //     }
          // });
        }
      },
      getCampusList(command) {
        // this.campusNow = command;
        localStorage.setItem("campus", command);
        this.campus();
        this.$message.success("已切换到" + this.campusNow + "地区");
      },
      //个人信息
      userInfo() {
        this.$router.push("/userInfo");
      },
      //用户退出
      logout() {
        this.$message.success('退出成功');
        window.sessionStorage.clear();
        this.$router.push("/login");

        // const param = {
        //     token: window.localStorage.getItem('token')
        // }
        // console.log(param);
        // this.$axios.getOutAdmin(param).then(res=>{
        //     console.log(res);
        //     if(res.code == 0){
        //         this.$message.warning(res.token);
        //         window.localStorage.clear();
        //         this.$router.push("/login");
        //     }
        // }).catch(error=>{
        //     console.log(error);
        // })

      },

      setNowTimes() {
        //获取当前时间
        let myDate = new Date();
        let wk = myDate.getDay();
        let yy = String(myDate.getFullYear() + "年");
        let mm = myDate.getMonth() + 1 + "月";
        let dd = String(
          myDate.getDate() < 10 ? "0" + myDate.getDate() : myDate.getDate() + "日"
        );
        let weeks = [
          "星期日",
          "星期一",
          "星期二",
          "星期三",
          "星期四",
          "星期五",
          "星期六",
        ];
        let week = weeks[wk];
        this.nowDate = yy + "-" + mm + "-" + dd;
        this.nowWeek = week;
      },
      changePassword() {
        this.dialogPassword = true
      },
      pwdReset_dialogForm(formName) {
        this.dialogPassword = false
        this.$nextTick(() => {
          this.$refs[formName].resetFields()
        })
      },
      pwdSubmitForm(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {

            const param = {
              id: sessionStorage.getItem('user_id'),
              password: hexMD5(this.pwdForm.password),
              repassword:hexMD5(this.pwdForm.repassword),
              access_token: sessionStorage.getItem('token'),
            }
            this.$axios.shopUserChangePsw(param).then(res => {
              if(res.code==200){
                this.$message.success(res.msg)
                this.dialogPassword = false
              }

            }).catch(function (error) {
              console.log(error);
            })
          }
        })
      },

    }
  }

</script>

<style scoped>
  .el-header {
    background-color: #fff;
    display: flex;
    justify-content: space-between;
    padding-left: 0;
    align-items: center;
    color: #333;
    font-size: 20px;
  }
  .top_head_left {
    width: 500px;
    display: flex;
    align-items: center;
  }
  .top_head_left img {
    width: 50px;
    height: 50px;
  }
  .top_head_left span{
    margin-left: 15px;
  }
  .top_head_right {
    text-align: right;
  }
  .top_head_right img{
    width: 40px;
    height: 40px;
    border-radius: 50%;
    vertical-align: middle; margin-right: 10px;
  }
  .el-header .el-button {
    background-color: transparent;
    border: none;
    color: #333;
  }
  .top_head_center {
    font-size: 16px;
    margin-left: 55px;
  }
  .el-submenu__title{
    text-align: left;
  }
  .cont_flex{height: 50px !important;border-bottom: 1px solid #e8e8e8;}

</style>

